export default __webpack_public_path__ + "static/DigitalFinanceLogoWithSpacingPink-4c0a43bba507cac27b3e205c08ca3559.png";